import {
  CharacteristicsItemWrapper,
  CharacteristicsKey,
  CharacteristicsValue,
  CharacteristicsValueWrapper,
  CharacteristicsWrapper,
  LiftingWrapper,
  Divider,
} from './styles';

import ImageViewer from '../ImageViewer';
import { getImagesArray } from '../../hooks/useImagesArray';

const Lifting = ({ images, liftingLugs, liftingPosition }) => {
  const { imageArray } = getImagesArray(images || [], 10);

  return (
    <LiftingWrapper>
      <CharacteristicsWrapper>
        <CharacteristicsItemWrapper>
          <CharacteristicsKey>Number of Lifting Lugs</CharacteristicsKey>
          <CharacteristicsValueWrapper>
            <CharacteristicsValue>{liftingLugs}</CharacteristicsValue>
          </CharacteristicsValueWrapper>
        </CharacteristicsItemWrapper>
        <Divider />
        <CharacteristicsItemWrapper>
          <CharacteristicsKey>Position</CharacteristicsKey>
          <CharacteristicsValueWrapper>
            <CharacteristicsValue>{liftingPosition}</CharacteristicsValue>
          </CharacteristicsValueWrapper>
        </CharacteristicsItemWrapper>
      </CharacteristicsWrapper>

      <ImageViewer
        imageId={imageArray[7].imageId}
        containerStyle={{
          width: '47%',
          height: '320px',
        }}
      />
    </LiftingWrapper>
  );
};

export default Lifting;
